import type { Country } from '@/types';

export const COUNTRIES: Country[] = [
  { code: 'MX', name_es: 'México',     name_en: 'Mexico',     cities: ['Ciudad de México','Guadalajara','Monterrey','Querétaro','Puebla','Mérida','León','Toluca'] },
  { code: 'CO', name_es: 'Colombia',   name_en: 'Colombia',   cities: ['Bogotá','Medellín','Cali','Barranquilla','Bucaramanga'] },
  { code: 'PE', name_es: 'Perú',       name_en: 'Peru',       cities: ['Lima','Arequipa','Trujillo','Cusco'] },
  { code: 'CL', name_es: 'Chile',      name_en: 'Chile',      cities: ['Santiago','Valparaíso','Concepción','Antofagasta'] },
  { code: 'AR', name_es: 'Argentina',  name_en: 'Argentina',  cities: ['Buenos Aires','Córdoba','Rosario','Mendoza'] },
  { code: 'EC', name_es: 'Ecuador',    name_en: 'Ecuador',    cities: ['Quito','Guayaquil','Cuenca'] },
  { code: 'UY', name_es: 'Uruguay',    name_en: 'Uruguay',    cities: ['Montevideo','Punta del Este'] },
  { code: 'BO', name_es: 'Bolivia',    name_en: 'Bolivia',    cities: ['La Paz','Santa Cruz','Cochabamba'] },
  { code: 'CR', name_es: 'Costa Rica', name_en: 'Costa Rica', cities: ['San José','Heredia'] },
  { code: 'GT', name_es: 'Guatemala',  name_en: 'Guatemala',  cities: ['Ciudad de Guatemala','Quetzaltenango'] },
  { code: 'PA', name_es: 'Panamá',     name_en: 'Panama',     cities: ['Ciudad de Panamá','David'] },
  { code: 'DO', name_es: 'Rep. Dominicana', name_en: 'Dominican Republic', cities: ['Santo Domingo','Santiago'] },
  // Añadidos con el padrón real: hay socios en los cuatro. Tienen que
  // estar TAMBIÉN aquí, no solo en la tabla `countries` de la base. Esta
  // lista es la que traduce el código a nombre en las fichas, así que sin
  // ella una organización de El Salvador se leería «SV» en pantalla.
  { code: 'SV', name_es: 'El Salvador',       name_en: 'El Salvador',         cities: [] },
  { code: 'PR', name_es: 'Puerto Rico',       name_en: 'Puerto Rico',         cities: [] },
  { code: 'TT', name_es: 'Trinidad y Tobago', name_en: 'Trinidad and Tobago', cities: [] },
  { code: 'PY', name_es: 'Paraguay',          name_en: 'Paraguay',            cities: [] },
  // Segunda tanda, de la revisión del padrón corregido (migración 0010).
  { code: 'VE', name_es: 'Venezuela',         name_en: 'Venezuela',           cities: [] },
  { code: 'JM', name_es: 'Jamaica',           name_en: 'Jamaica',             cities: [] },
  { code: 'GY', name_es: 'Guyana',            name_en: 'Guyana',              cities: [] },
  { code: 'HN', name_es: 'Honduras',          name_en: 'Honduras',            cities: [] },
];

export function countryName(code: string | undefined, lang: 'es' | 'en'): string {
  if (!code) return '';
  const c = COUNTRIES.find((x) => x.code === code);
  if (!c) return code;
  return lang === 'es' ? c.name_es : c.name_en;
}

export const ROLES_INSTR = [
  'AutoCAD Instructor','Revit Instructor','Inventor Instructor','Civil 3D Instructor',
  '3ds Max Instructor','Maya Instructor','Fusion 360 Instructor','BIM 360 Instructor',
  'AutoCAD MEP Instructor','Revit Structure Instructor',
];

export const PRIMARY_ROLES = ['Site Director','Site Manager','Site Admin','Lead Instructor','Instructor'];

export const FNAMES = ['María','José','Carlos','Ana','Luis','Sofía','Diego','Camila','Andrés','Valentina','Miguel','Lucía','Javier','Daniela','Fernando','Paula','Roberto','Mariana','Eduardo','Gabriela','Pablo','Renata','Sergio','Adriana','Hugo','Isabel','Ricardo','Patricia','Felipe','Laura','Tomás','Florencia','Esteban','Ximena','Mauricio','Antonella','Iván','Carolina','Rafael','Natalia'];

export const LNAMES = ['García','Rodríguez','Martínez','López','Hernández','González','Pérez','Sánchez','Ramírez','Torres','Flores','Rivera','Gómez','Díaz','Reyes','Morales','Cruz','Ortiz','Castro','Romero','Vargas','Jiménez','Ríos','Mendoza','Suárez','Vega','Cárdenas','Aguilar','Salazar','Navarro'];
